import {cn} from '@ds/helpers';

type CouponInfoRowProps = {
  title: React.ReactNode;
  value: React.ReactNode;
  subtitle?: React.ReactNode;
  hasBorder?: boolean;
};

const CouponInfoRow: React.FC<CouponInfoRowProps> = ({
  title,
  value,
  subtitle,
  hasBorder = true
}) => {
  return (
    <div
      className={cn(
        'flex min-h-11 items-center justify-between gap-3 py-2 text-body-sm',
        hasBorder && 'border-b border-gray-22'
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="text-body-sm-emphasis text-neutral-fg">{title}</span>
        {subtitle ? <span className="text-body-sm text-gray-34">{subtitle}</span> : null}
      </div>
      <div className="shrink-0 text-neutral-fg">{value}</div>
    </div>
  );
};

export default CouponInfoRow;
